import * as authHooks from "@rentiohq/shared-frontend/dist/redux/auth/auth.hooks";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { Page, Tabs } from "@rentiohq/web-shared-next/dist/ui-components";
import React from "react";
import { matchPath } from "react-router";
import { useLocation, Outlet } from "react-router-dom";
import { EProfileTabs } from "./Profile.types";

export const ProfileContainer = () => {
  const location = useLocation();
  const { pathname } = location;

  const { user } = authHooks.useSelf();

  const [activeTab, setActiveTab] = React.useState(EProfileTabs.Personal);

  React.useEffect(() => {
    if (pathname) {
      setActiveTab(
        // @ts-ignore
        tabs.find(tab => !!matchPath(tab.link, location.pathname))?.tabIndex,
      );
    }
  }, [pathname]);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) =>
    setActiveTab(newValue);

  const locale = user?.locale;

  const tabs = React.useMemo(() => {
    return [
      {
        label: getLocalizedText("profile.detail.tabs.personal"),
        tabIndex: EProfileTabs.Personal,
        link: "/profile/personal",
      },
      {
        label: getLocalizedText("profile.detail.tabs.extra"),
        tabIndex: EProfileTabs.Extra,
        link: "/profile/extra",
      },
      {
        label: getLocalizedText("profile.detail.tabs.tac"),
        tabIndex: EProfileTabs.Tac,
        link: "/profile/tac",
      },
      {
        label: getLocalizedText("profile.detail.tabs.more"),
        tabIndex: EProfileTabs.More,
        link: "/profile/more",
      },
    ];
  }, [locale]);

  return (
    <Page title={getLocalizedText("profile.title")}>
      <Tabs
        tabs={tabs}
        activeTab={activeTab}
        handleTabChange={handleTabChange}
      />
      <Outlet />
    </Page>
  );
};
